import * as React from 'react'
import { cn } from '../lib/utils'

/**
 * `FormGrid` (FO-060) — 1-koloms op mobiel, meerkoloms op desktop (`md+`).
 * Vervangt kale `grid grid-cols-2/3` in formulieren zodat velden op 375px niet
 * samengeperst worden. Puur presentatie.
 */
export interface FormGridProps extends React.HTMLAttributes<HTMLDivElement> {
  /** Aantal kolommen op desktop (md+). Mobiel is altijd 1-koloms. */
  columns?: 1 | 2 | 3 | 4
}

const colsClass: Record<NonNullable<FormGridProps['columns']>, string> = {
  1: '',
  2: 'md:grid-cols-2',
  3: 'md:grid-cols-3',
  4: 'md:grid-cols-4',
}

export function FormGrid({ columns = 2, className, ...props }: FormGridProps) {
  return (
    <div className={cn('grid grid-cols-1 gap-4', colsClass[columns], className)} {...props} />
  )
}
